<template>
  <div class="v-table bootstrap">
    <v-client-table
      :data="tableData"
      :columns="tableColumns"
      :options="tableOptions"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import * as moment from 'moment';

import { ClientTable } from 'vue-tables-2';

Vue.use(ClientTable);

export default {
  props: ['options'],
  data() {
    return {};
  },
  computed: {
    tableColumns() {
      return this.options.columns;
    },
    tableData() {
      return this.options.data;
    },
    tableOptions() {
      const headings = {};
      const texts = {};
      let options = {
        headings,
        texts,
        filterable: false,
        footerHeadings: false,
        orderBy: {
          column: 'content_name',
          ascending: true,
        },
        pagination: {
          chunk: 10,
          dropdown: false,
        },
        perPage: 10,
        perPageValues: [10, 50, 100],
        templates: {
          date(h, row) {
            if (row.date.date) {
              return moment(row.date.date).format('MMM Do, YYYY');
            }
            return moment(row.date).format('MMM Do, YYYY');
          },
        },
      };

      if (this.options.tableOptions) {
        options = Object.assign(options, this.options.tableOptions);
      }

      return options;
    },
  },
  mounted() {
    // console.log(this.data);
  },
};
</script>
